import React, { createContext, useContext } from "react";

interface DevContextType {
  /** Whether dev mode is active (DEV build only) */
  isDevMode: boolean;
}

const DevContext = createContext<DevContextType>({
  isDevMode: false,
});

export function DevProvider({
  children,
  userEmail,
  userId,
}: {
  children: React.ReactNode;
  userEmail: string | null | undefined;
  userId: string | null | undefined;
}) {
  const isDevMode = __DEV__;

  return (
    <DevContext.Provider value={{ isDevMode }}>
      {children}
    </DevContext.Provider>
  );
}

export function useDev() {
  return useContext(DevContext);
}
